import Glide, {
    Controls,
    Autoplay
} from '@glidejs/glide/dist/glide.modular.esm';




const glide = new Glide('.glide', {
    type: 'carousel',
    startAt: 0,
    perView: 1
}).mount();


const glideHero = new Glide('.glide-hero', {
    type: 'carousel',
    startAt: 0,
    autoplay: 5000,
    hoverpause: false,
    perView: 1,

}).mount({
    Autoplay
});

// console.log(glideHero);

const buttons = document.querySelectorAll('.choose-service__buttons .btn');
const slider = document.querySelector('.glide');

// console.log('buttons', buttons);
// console.log('slider', slider);
for (let i = 0; i < buttons.length; i++) {
    // console.log(button);
    buttons[i].addEventListener('click', () => {
        // console.log("KLIK");
        slider.scrollIntoView({
            behavior: 'smooth'
        });
        glide.go(`=${i}`);

    });
}